import { socialLogin, socialSignup } from "@/social/index.js";

const facebook = {
  init() {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: process.env.VUE_APP_SOCIAL_FACEBOOK_ID,
        cookie: true,
        xfbml: true,
        version: "v9.0"
      });
      window.FB.AppEvents.logPageView();
    };
    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  },

  async login() {
    const req = await this.getInfo();
    console.log(req);
    await socialLogin(req);
  },

  async signup() {
    const req = await this.getInfo();
    await socialSignup(req);
  },

  async LoginFailure() {
    return false;
  },

  getInfo() {
    return new Promise((resolve, reject) => {
      window.FB.getLoginStatus(() => {
        // 첫 시도
        window.FB.login(
          response => {
            if (response.status === "connected") {
              // const accessToken = response.authResponse.accessToken;
              window.FB.api(
                "/me",
                { fields: "id, name, email, picture" },
                res => {
                  if (!res) this.LoginFailure();
                  const req_body = {
                    id: res.id,
                    name: res.name,
                    email: res.email,
                    picture: res.picture.data.url,
                    social: "facebook"
                  };
                  resolve(req_body);
                }
              );
            } else {
              this.LoginFailure();
            }
          },
          { scope: "public_profile, email" }
        );
      });
    });
  }
};

export default facebook;
